import { useCallback } from 'react';
import type { Lens } from '@hookform/lenses';
import { useController } from 'react-hook-form';
import {
  MultiSelectInput,
  type MultiSelectInputEvent,
  type MultiSelectInputProps,
} from '@interxfi/design-system/components/input/multi-select-input/multi-select-input';

const stableArrayRef = [] as const satisfies string[];

interface PropsWithLens<T extends string = string> extends Omit<MultiSelectInputProps, 'name' | 'value'> {
  shouldUnregister?: boolean;
  lens: Lens<T[]>;
}

export function AppMultiSelectInputWithLens<T extends string = string>({ onChange, shouldUnregister, lens, ...props }: PropsWithLens<T>) {
  // TODO: remove any cast (lens library is new, doesn't support generics well yet)
  const { field, fieldState } = useController({ shouldUnregister, ...(lens.interop() as any) });
  const { onChange: fieldOnChange } = field;
  const handleChange = useCallback(
    (e: MultiSelectInputEvent) => {
      fieldOnChange(e.target.value);
      onChange?.(e);
    },
    [fieldOnChange, onChange],
  );

  return (
    <MultiSelectInput
      {...props}
      {...field}
      error={fieldState.error?.message}
      onChange={handleChange}
      touched={fieldState.isTouched}
      value={field.value || stableArrayRef}
    />
  );
}
